import RawAliases from '../../../../data/AzPolicyAliases.json';
import RawModAliases from '../../../../data/modAlias.json';
import { ModAliasSchema, AliasEntry } from './types';

// Normalize raw aliases by resource type, handling string or array
interface RawGroup { ResourceType: string; Aliases: string | string[]; }
const aliasGroups = (RawAliases as RawGroup[]).map(group => ({
  ResourceType: group.ResourceType,
  Aliases: Array.isArray(group.Aliases)
    ? group.Aliases
    : typeof group.Aliases === 'string'
    ? [group.Aliases]
    : [],
}));
// Flatten into simple alias entries (also keep a lowercase key for lookup)
const aliases = aliasGroups.flatMap(group =>
  group.Aliases.map(alias => ({
    alias,
    resourceType: group.ResourceType,
    resourceTypeKey: group.ResourceType.toLowerCase(),
  }))
);
// Parse modifiable alias list
const modList = ModAliasSchema.parse(RawModAliases);

// Unique list of resource types for dropdown
export const resourceTypes: string[] = Array.from(
  new Set(aliasGroups.map(g => g.ResourceType))
).sort();

/**
 * Fetch aliases for a given resource type
 */
export function fetchAliasesByResourceType(
  resourceType: string
): Promise<AliasEntry[]> {
  const normalizedType = resourceType.trim().toLowerCase();
  const filtered = aliases
    .filter(a => a.resourceTypeKey === normalizedType)
    .map(a => ({
      id: a.alias,
      resourceType: a.resourceType,
      modifiable: modList.includes(a.alias),
    }));
  return Promise.resolve(filtered);
} 
